import { createConfirmationModal, closeModal, showModal } from "./modals";
import { i18n } from "./i18n";

Turbo.config.forms.confirm = (content) => {
  return new Promise((resolve) => {
    const onConfirm = (() => {
      closeModal(modal);
      resolve(true);
    }).bind(this);

    const onClose = () => {
      resolve(false);
    };

    const okButtonClass = "btn_primary";

    const modal = createConfirmationModal({
      title: i18n.t("list_table.confirmation_title"),
      content,
      okButton: i18n.t("actions.ok"),
      okButtonClass,
      onConfirm,
      onClose
    });

    showModal(modal);

    modal.addEventListener("click", (event) => {
      if (modal.dataset.staticBackdrop !== undefined) return;
      if (modal !== event.target) return;
      closeModal(modal);
      onClose();
    });
  });
};
